/* eslint-disable no-case-declarations */
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Paper,
  Divider,
  useTheme,
  useMediaQuery,
  AppBar,
  Toolbar,
  Container,
  Stack,
  Snackbar,
  Alert,
  IconButton,
  Tooltip
} from '@mui/material';
import AccountPopover from 'src/layouts/common/account-popover';
import {HEADER} from 'src/layouts/config-layout';
import {bgBlur} from 'src/theme/css';
import {useSettingsContext} from 'src/minimal-components/settings';
import Logo from 'src/minimal-components/logo';
import Main from 'src/layouts/dashboard/main';
import {useLocation, useNavigate} from 'react-router-dom';
import {
  LMS_TYPE,
  BASE_RECORD_ID,
  BASE_UNIQUE_ID,
  LMS_MODULE_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  PARAMS_KEY,
  LMS_PREVIEW_ID,
  MOVE_TO_TAB,
  LMS_IS_ADMIN,
  BASE_UNIQUE_TYPE
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import FormConstants from '@shared/constants/FormConstants';
import {
  getLMSResultsData,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import {useAppContext} from '@context/AppContext';
import {useState} from 'react';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {enqueueSnackbar} from 'src/minimal-components/snackbar';
import React from 'react';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {LoadingButton} from '@mui/lab';
import {CloseIcon} from 'yet-another-react-lightbox';
import { environment } from '@shared/config/environment';
import { sanitizeHtml } from 'src/utils/htmlSanitizer';

const TestPage = () => {
  const theme = useTheme();
  const {
    appState: {applicationName}
  } = useAppContext();
  const navigate = useNavigate();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const [isLoading, setIsloading] = React.useState(false);
  const [isPreviewLoading, setIsPreviewloading] = React.useState(false);
  const [uiFields, setUiFields] = React.useState<any>();
  const [fieldsData, setFeildsData] = React.useState<any>();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const subSection = query.get('subsection');
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
 const filetype=EncryptUtils.getDecryptedData(
      location?.search,
      BASE_UNIQUE_TYPE
    );
  const subModuleName = EncryptUtils.getDecryptedData(
    location?.search,
    MOVE_TO_TAB
  );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const init = async () => {
    try {
      setIsloading(true);
      const res = await getSearchForm(
        applicationName,
        'module',
        'PreviewIntro'
      );
      setUiFields(res.searchForm);
      if (res.searchForm) {
        let sqlName;
        const operations = 'SEARCH';
        let TableName;
        let TableQuestions;
        switch (subModuleName) {
          case 'pre_learning_activities':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            sqlName = 'PreLearning_sql';
            break;
          case 'post_learning_activities':
            (TableName = 'SettingsPostLearningTestList'),
              (TableQuestions = 'SettingsPostLearningQuestionsStorage');
            sqlName = 'PostLearning_sql';
            break;
          case 'prepost_feedback':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            break;
          case 'ModuleMain':
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
          default:
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
        }
        if (sqlName) {
          const {sqldata} = res.searchForm[sqlName];

          const data: any = {
            sql_data: sqldata,
            data: {
              id: fileId,
              course_overview_id: uniqueId,
              isAdmin: lmsisAdmin === 'True'
            },
            operation: operations
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });

          //console.log('dataresult', result);
          if (result.data[0]) {
            setFeildsData(result.data[0]);
          }
        }
        setIsloading(false);
      }
      setIsloading(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      setIsloading(false);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  const PreviewSaving = async () => {
    try {
      setIsPreviewloading(true);
      if (uiFields) {
        let sqlName;
        let TableName;
        let TableQuestions;
        switch (subModuleName) {
          case 'pre_learning_activities':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            sqlName = 'PreLearning_sql';
            break;
          case 'post_learning_activities':
            (TableName = 'SettingsPostLearningTestList'),
              (TableQuestions = 'SettingsPostLearningQuestionsStorage');
            sqlName = 'PostLearning_sql';
            break;
          case 'prepost_feedback':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            break;
          case 'ModuleMain':
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
          default:
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
        }
        const operations = 'INSERT';
        if (sqlName) {
          const {sqldata} = uiFields[sqlName];
          const data: any = {
            sql_data: sqldata,
            data: {
              id: fileId,
              ModuleName: subModuleName,
              course_overview_id: uniqueId,
              OperationType: lmstype
            },
            operation: operations
          };

          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          setIsPreviewloading(false);
          //console.log('result', result);
          return result.data[0];
        }
        // if (result.data[0]) {
        //   setFeildsData(result.data[0]);
        // }
      }
      setIsPreviewloading(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      setIsPreviewloading(false);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  React.useEffect(() => {
    const fetchData = async () => {
      await init();
    };

    fetchData();
  }, []);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };
  const onRoleChange = async () => {
    const value = await PreviewSaving();
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: uniqueId,
      [LMS_TYPE]: lmstype,
      [BASE_UNIQUE_ID]: fileId,
         [BASE_UNIQUE_TYPE]:filetype,
      [LMS_MODULE_ID]: moduleId,
      [LMS_PREVIEW_ID]: value.inserted_id,
      [MOVE_TO_TAB]: subModuleName,
      [LMS_IS_ADMIN]: lmsisAdmin
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/OnlineTest/Questions?${PARAMS_KEY}=${paramsKey}`,
      {
        state: {}
      }
    );
  };
  const settings = useSettingsContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const renderContent = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
      }}>
      <Logo
        disabledLink={true}
        applicationName={'LMS'}
        sx={{mt: 3, ml: 4, mb: 1}}
      />
      <Box>
        {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED  &&<AccountPopover isDashboard={true} /> }
        <Tooltip title="Close">
          <IconButton onClick={() => navigate(-1)}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
  return (
    <>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(to right, #3a7bd5, #3a6073)',
          color: 'white'
        }}>
        <Toolbar
          sx={{
            height: 1,
            backgroundColor: 'white'
            // px: {lg: 5}
          }}>
          {renderContent}
        </Toolbar>
        {isLoading ? (
          <Stack
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            minHeight={'80vh'}>
            <LoadingScreen />
          </Stack>
        ) : (
          <Box
            sx={{
              minHeight: '85vh',
              background: 'linear-gradient(to right, #3a7bd5, #3a6073)',
              padding: {xs: 2, sm: 4}
            }}>
            {/* Title */}
            <Typography
              variant="h4"
              sx={{
                color: 'white',
                textAlign: 'center',
                fontWeight: 'bold',
                paddingBottom: 3
              }}>
              {fieldsData?.name}
            </Typography>

            {/* Main Card */}
            <Paper
              // elevation={3}
              sx={{
                maxWidth: '60vw',
                margin: '0 auto',
                padding: 3,
                borderRadius: '10px'
              }}>
              {/* Test Info */}
              <Card
                sx={{
                  backgroundColor: '#f8f9fa',
                  marginTop: 3,
                  padding: 2,
                  boxShadow:
                    '0px 3px 3px -2px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)',
                  borderRadius: '8px'
                }}>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent={'space-between'}>
                  <Grid item>
                    <Typography variant="subtitle2" color="text.secondary">
                      <strong>Date</strong>
                    </Typography>
                    <Typography variant="body1">
                      {new Date().toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </Typography>
                  </Grid>
                  {/* Dynamically Render Fields */}
                  {[
                    {
                      label: 'Duration',
                      value:
                        fieldsData?.overallTime_in_minutes ||
                        fieldsData?.TotalTimeInMinutes
                    },
                    {
                      label: 'Total Questions',
                      value: fieldsData?.TotalQuestions
                    },
                    {label: 'Total Marks', value: fieldsData?.TotalMarks},
                    {
                      label: 'Pass Percentage',
                      value: fieldsData?.pass_percentage
                    }
                  ]
                    .filter(
                      field => field.value !== undefined && field.value !== null
                    ) // Ensure only valid fields are shown
                    .map((field, index) => (
                      <Grid key={index} item>
                        <Typography variant="subtitle2" color="text.secondary">
                          <strong>{field.label}</strong>
                        </Typography>
                        <Typography variant="body1">{field.value}</Typography>
                      </Grid>
                    ))}

                  {/* Action Button */}
                  <Grid item>
                    <Box sx={{textAlign: 'right'}}>
                      <LoadingButton
                        variant="contained"
                        color="primary"
                        size="large"
                        loading={isPreviewLoading}
                        onClick={() => {
                          if (fieldsData?.TotalQuestions > 0) {
                            onRoleChange();
                          } else {
                            setOpenSnackbar(true);
                          }
                        }}>
                        Start →
                      </LoadingButton>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
              {/* Start Button */}

              {/* Note Section */}
              <Card
                sx={{
                  backgroundColor: '#f8f9fa',
                  marginTop: 3,
                  boxShadow:
                    '0px 3px 3px -2px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)',
                  borderRadius: '8px'
                }}>
                <CardContent>
                  <Typography variant="subtitle1" sx={{fontWeight: 'bold'}}>
                    Note
                  </Typography>
                  <Divider sx={{marginBottom: 1}} />
                  <ul style={{paddingLeft: '16px'}}>
                    <li>
                      Once a test attempt is initiated, it will still be counted
                      as an attempt even if the browser tab is closed or if the
                      page was reloaded without completing the test.
                    </li>
                    {fieldsData?.TotalTimeInMinutes && (
                      <li>
                        {`You are expected to complete the entire test within the
                        allotted ${fieldsData?.TotalTimeInMinutes} minutes.`}
                      </li>
                    )}
                    {fieldsData?.overallTime_in_minutes && (
                      <li>
                        {`You are expected to complete the entire test within the
                        allotted ${fieldsData?.overallTime_in_minutes} minutes.`}
                      </li>
                    )}
                    <li>
                      Match questions are not accessible for visually impaired
                      users.
                    </li>
                  </ul>
                </CardContent>
              </Card>

              {/* Instructions Section */}
              {fieldsData?.introduction_info && (
                <Card
                  sx={{
                    backgroundColor: '#f8f9fa',
                    marginTop: 3,
                    boxShadow:
                      '0px 3px 3px -2px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)',
                    borderRadius: '8px'
                  }}>
                  <CardContent>
                    <Typography variant="subtitle1" sx={{fontWeight: 'bold'}}>
                      Instructions
                    </Typography>
                    <Divider sx={{marginBottom: 1}} />

                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(fieldsData?.introduction_info)
                      }}
                      style={{
                        padding: '10px',
                        position: 'relative',
                        overflowY: 'auto',
                        height: '100%',
                        width: '100%'
                      }}
                    />
                  </CardContent>
                </Card>
              )}
            </Paper>
          </Box>
        )}
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
        <Alert
          onClose={handleSnackbarClose}
          severity="warning"
          sx={{width: '40vw'}}>
          This Test can not be Attempted
        </Alert>
      </Snackbar>
    </>
  );
};

export default TestPage;

